{
  "completed": "Fuldført: ",
  "current": "Nuværende: ",
  "notCompleted": "Ikke afsluttet: ",
  "steplist": "Trinliste"
}
